module.exports = __webpack_public_path__ + "static/media/27PerformancePhotos.90b06d3a.jpeg";